



















































































































import { Component, Vue, Watch, Ref } from 'vue-property-decorator';
import { mapState } from 'vuex';
import _ from 'lodash';

@Component({
  computed: {
    ...mapState('Auth', {
      activeUser: 'user',
      isImpersonate: 'isImpersonate',
    }),
    ...mapState('User', {
      user: 'adminUser',
      normalGroups: 'normalGroups',
    }),
  },
})
export default class UserProfileGeneral extends Vue {
  @Ref() readonly form!: { setErrors: (any?: any) => void };
  user!: Model;

  tmpUser = {};

  isLoading = false;

  get isChanged() {
    const user = this.user;
    for (const key in user) {
      if (this.user[key] !== this.tmpUser[key]) {
        if (key != 'ubg') {
          return true;
        }
      }
    }
    return false;
  }

  @Watch('user', { deep: true })
  watchUser(v) {
    if (v) {
      this.tmpUser = _.cloneDeep(v);
    }
  }

  mounted() {
    if (this.user) {
      this.tmpUser = _.cloneDeep(this.user);
    }
  }

  update() {
    if (!this.isChanged || this.isLoading) {
      return false;
    }

    this.isLoading = true;

    const userInfo = {};
    for (const key in this.user) {
      if (this.user[key] !== this.tmpUser[key]) {
        userInfo[key] = this.tmpUser[key];
      }
    }
    this.$store
      .dispatch('User/update', {
        id: this.$route.params.userId,
        payload: userInfo,
      })
      .then(() => {
        this.isLoading = false;
        this.$store.commit('SET_SNACKBAR', {
          show: true,
          type: 'success',
          message: this.$i18n.t('common_word.success_update'),
        });
      })
      .catch(({ response }) => {
        this.isLoading = false;
        this.form.setErrors(response.data.error);
      });
  }

  impersonate() {
    this.isLoading = true;
    this.$store.dispatch('User/impersonate', {
      id: this.user.id,
    });
  }
}
